module.exports = __webpack_public_path__ + "static/img/jingxin.4fe3c8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/jingxin.jpg
// module id = ptkL
// module chunks = 1